module.exports = __webpack_public_path__ + "img/icon__successful.f6e37620.svg";